import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { VirtualDataroom } from "@/models/virtual-data-room/VirtualDataRoom";
import { VirtualDataRoomCopy } from "@/models/virtual-data-room/VirtualDataRoomCopy";
import { VirtualDataRoomCreation } from "@/models/virtual-data-room/VirtualDataRoomCreation";
import { VirtualDataRoomFile } from "@/models/virtual-data-room/VirtualDataRoomFile";
import { VirtualDataRoomFileNode } from "@/models/virtual-data-room/VirtualDataRoomFileNode";
import { VirtualDataRoomFinancialsCreation } from "@/models/virtual-data-room/VirtualDataRoomFinancialsCreation";
import { VirtualDataRoomHomeFilterOptions } from "@/models/virtual-data-room/VirtualDataRoomHomeFilterOptions";
import axios from "axios";

class VirtualDataRoomService {
  private path: string;
  constructor(path: string) {
    this.path = path;
    axios.interceptors.request.use((r) => {
      console.log(r);
      return r;
    });
  }

  getAll(includeThumbnailUrls: boolean): Promise<ApiResponseV2<VirtualDataroom[]>> {
    return HttpClientV2.get(`${this.path}/all?includeThumbnailUrls=${includeThumbnailUrls}`);
  }

  create(dto: VirtualDataRoomCreation): Promise<ApiResponseV2<VirtualDataroom>> {
    return HttpClientV2.post(`${this.path}`, dto, {
      axiosConfig: {
        timeout: 60000,
      },
    });
  }

  getByExternalId(externalId: string): Promise<ApiResponseV2<VirtualDataroom>> {
    return HttpClientV2.get(`${this.path}?externalId=${externalId}`);
  }

  getTreeByExternalId(externalId: string): Promise<ApiResponseV2<VirtualDataRoomFileNode>> {
    return HttpClientV2.get(`${this.path}/tree?externalId=${externalId}`);
  }

  deleteByExternalId(externalId: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.delete(`${this.path}?externalId=${externalId}`);
  }

  updateProfileImage(externalId: string, file: File): Promise<ApiResponseV2<VirtualDataroom>> {
    const formData = new FormData();
    formData.append("file", file);
    return HttpClientV2.post(`${this.path}/${externalId}/update-img/profile`, formData, {
      axiosConfig: {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    });
  }

  updateBannerImage(externalId: string, file: File): Promise<ApiResponseV2<VirtualDataroom>> {
    const formData = new FormData();
    formData.append("file", file);
    return HttpClientV2.post(`${this.path}/${externalId}/update-img/banner`, formData, {
      axiosConfig: {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    });
  }

  updateSettings(dto: VirtualDataroom): Promise<ApiResponseV2<VirtualDataroom>> {
    return HttpClientV2.put(`${this.path}/update-settings`, dto);
  }

  updateFileDataRoomSettings(dto: VirtualDataroom): Promise<ApiResponseV2<VirtualDataroom>> {
    return HttpClientV2.patchWithPayload(`${this.path}/update-file-room-settings`, dto);
  }

  deleteProfileImage(externalId: string): Promise<ApiResponseV2<VirtualDataroom>> {
    return HttpClientV2.delete(`${this.path}/${externalId}/delete-img/profile`);
  }

  deleteBannerImage(externalId: string): Promise<ApiResponseV2<VirtualDataroom>> {
    return HttpClientV2.delete(`${this.path}/${externalId}/delete-img/banner`);
  }

  copyFromMaster(dto: VirtualDataRoomCopy): Promise<ApiResponseV2<VirtualDataRoomFile[]>> {
    return HttpClientV2.post(`${this.path}/master/copy`, dto);
  }

  getFilterOptions(): Promise<ApiResponseV2<VirtualDataRoomHomeFilterOptions>> {
    return HttpClientV2.get(`${this.path}/home/filter-options`);
  }

  createFileRoom(f: File, tenantExternalId: string): Promise<ApiResponseV2<VirtualDataroom>> {
    const formData = new FormData();
    formData.append("file", f);
    return HttpClientV2.post(`${this.path}/file?tenantExternalId=${tenantExternalId}`, formData, {
      axiosConfig: {
        timeout: 40000,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    });
  }

  createFinancialsRoom(dto: VirtualDataRoomFinancialsCreation): Promise<ApiResponseV2<VirtualDataroom>> {
    return HttpClientV2.post(`${this.path}/financial`, dto);
  }
}

export default new VirtualDataRoomService("/api/virtual-data-room");
